import { paths } from "helpers/paths";
import { paramsObject } from "helpers/system";
import policy from "policies";
import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/books/distributionBids";
import { applyDistributionBid, getForDistributionBid } from "sources/shippingOrders";
import Form from "./form";
import List from "./list";
import Show from "./show";

export default class DistributionBids extends Component {
    render() {
        const { match, location, history, roles } = this.props;
        const rootUrl = `${match.path}/list`;
        let back = () => history.push(rootUrl);
        const isOnlyExtendedViewer = policy("user", { user: { roles } }).isOnlyExtendedViewer();
        return (
            <div className="page-content">
                <Switch location={location}>
                    <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                    <Route
                        exact
                        path={rootUrl}
                        render={() => (
                            <List {...this.props} isTable transition="full" title="Нераспределенные заказы" nofilter />
                        )}
                    />
                    <Route
                        exact
                        path={`${rootUrl}/new`}
                        render={(props) => {
                            if (isOnlyExtendedViewer) {
                                return <Redirect to={rootUrl} />;
                            }
                            const { sourceId, isCopy, shippingOrderId } = paramsObject(props.location.search);
                            const parsedShippingOrderId = Number(shippingOrderId);
                            const fromShippingOrder =
                                Number.isInteger(parsedShippingOrderId) && parsedShippingOrderId > 0;
                            return (
                                <Form
                                    {...this.props}
                                    isCopy={isCopy === "true"}
                                    sourceId={sourceId}
                                    title={fromShippingOrder ? "Новый заказ по ЭЗЗ" : "Новый заказ"}
                                    back={
                                        fromShippingOrder
                                            ? () => history.push(paths.shippingOrdersShow(parsedShippingOrderId))
                                            : back
                                    }
                                    loadNewItem={
                                        fromShippingOrder
                                            ? () => getForDistributionBid(parsedShippingOrderId)
                                            : undefined
                                    }
                                    submit={
                                        fromShippingOrder
                                            ? ({ items }) =>
                                                  applyDistributionBid({
                                                      ...items[0],
                                                      shippingOrderId: parsedShippingOrderId,
                                                  })
                                            : source.apply
                                    }
                                    action="new"
                                />
                            );
                        }}
                    />
                    <Route
                        exact
                        path={`${match.path}/edit/:id`}
                        render={(rest) => {
                            if (isOnlyExtendedViewer) {
                                return <Redirect to={rootUrl} />;
                            }
                            const { id } = rest.match.params;
                            const { isCopy, editRoute } = paramsObject(rest.location.search);
                            back = () => history.push(paths.distributionBidShow(id));
                            return (
                                <Form
                                    {...rest}
                                    title="Редактирование заказа"
                                    back={back}
                                    source={source}
                                    action="edit"
                                    isCopy={isCopy === "true"}
                                    editRoute={editRoute}
                                />
                            );
                        }}
                    />
                    <Route
                        exact
                        path={`${match.path}/bid/:id`}
                        render={(rest) => {
                            const { id } = rest.match.params;
                            return <Show {...rest} title="Заказ" back={back} source={source} id={id} />;
                        }}
                    />
                </Switch>
            </div>
        );
    }
}
